import './lib/css'
import './lib/script'
import './lib/global'

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import ElementUI from 'element-ui'
Vue.use(ElementUI)

import VueAnalytics from 'vue-analytics'
Vue.use(VueAnalytics, {
  id: 'UA-104601609-1',
  router,
  autoTracking: {
    pageviewTemplate(route) {
      return {
        page: route.path,
        title: document.title,
        location: window.location.href
      }
    }
  }
})

import NProgress from 'vue-nprogress'
const options = {
  showSpinner: false,
  latencyThreshold: 200, // Number of ms before progressbar starts showing, default: 100,
  router: true, // Show progressbar when navigating routes, default: true
  http: false // Show progressbar when doing Vue.http, default: true
}

Vue.use(NProgress, options)
const nprogress = new NProgress({
  parent: '.nprogress-container'
})

import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  installComponents: true,
  load: {
    key: 'AIzaSyCT4wHCRqtHYuwbm8tNZXb6LYcIe0c9dIY',
    v: '3.29',
    libraries: 'places',
    language: 'en'
  }
})
Vue.filter('json', x => JSON.stringify(x))

import axios from './api/http'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

import ECharts from 'vue-echarts/components/ECharts.vue'

import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/pie'
import 'echarts/lib/chart/map'
import 'echarts/lib/chart/radar'
import 'echarts/lib/chart/scatter'
import 'echarts/lib/chart/effectScatter'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/polar'
import 'echarts/lib/component/geo'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'
import 'echarts/lib/component/visualMap'
import theme from './assets/theme.json'
ECharts.registerTheme('default', theme)
Vue.component('chart', ECharts)

import i18n from './assets/lang'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  nprogress,
  i18n,
  store,
  axios,
  router,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js